/*
 * To use, add native `audio` elements with the `data-capture-actions="true"`
 * attribute.
 *
 * In your initialization code, do
 * `import RDAudioEventCapture from "audio-event-capture";`
 * `RDAudioEventCapture.initialize(function (audioForm) { ... });
 *
 * Here the `audioForm` will be a hidden HTML form on the page that can be
 * submitted with the captured audio event. E.g.
 * `Rails.fire(audioForm, "submit");`
 */

require('./shared/init.js');
import ensureForEach from './shared/init.js';

export default class RDAudioEventCapture {
  static initialize(eventCallback, eventKinds = ['play', 'pause', 'ended']) {
    ensureForEach();
    let audioElements = document.querySelectorAll(
      "audio[data-capture-actions='true']"
    );

    audioElements.forEach(function (audio) {
      let audioForm = document.createElement('form');
      audioForm.id = `${audio.id}-form`;
      audioForm.action = audio.dataset.apiUrl;
      audioForm.method = 'post';
      audioForm.dataset.remote = 'true';
      audioForm.dataset.type = 'json';
      audioForm.style.display = 'none';
      audioForm.innerHTML = `
        <input name="audio_action[audio_id]" value="${audio.dataset.audioId}" />
        <input name="audio_action[kind]" value="" />
        <input name="audio_action[current_playback_time_in_s]" value="" />
      `;
      document.body.appendChild(audioForm);
      eventKinds.forEach((kind) => {
        audio.addEventListener(kind, reportAudioEvent);
      });

      function reportAudioEvent(event) {
        audioForm.querySelector("[name='audio_action[kind]']").value =
          event.type;
        audioForm.querySelector(
          "[name='audio_action[current_playback_time_in_s]']"
        ).value = audio.currentTime;
        eventCallback(audioForm, audio, event);
      }
    });
  }
}
